import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { saveFileFromResponse } from '../../../utils/fileUtils';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { getAppendixDocument } from '../../generated/client';

export const useDownloadAppendixDocument = (): UseMutationResult<AxiosResponse, AxiosError, number> => {
    const { t } = useTranslation();

    return useMutation({
        mutationFn: async (documentId) => (await getAppendixDocument({ path: { documentId }, responseType: 'arraybuffer' })) as AxiosResponse,
        onSuccess: (response) => {
            showSuccessToast(t('clientPackageAppendixDocumentDownloadSuccess'));
            const axiosResponse = response as AxiosResponse<string>;
            saveFileFromResponse(axiosResponse);
        },
        onError: (error) => showErrorToast({ error, userMessage: t('clientPackageAppendixDocumentDownloadFailure') }),
    });
};
